import { createReducer } from '@reduxjs/toolkit';

import getOrderDoneByList from '../../thunks/general/getOrderDoneByList';

const initialState = {
  loading: false,
  error: null,
  data: [],
};

const getOrderDoneByListReducer = createReducer(initialState, {
  [getOrderDoneByList.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [getOrderDoneByList.fulfilled]: (state, { payload: { data } }) => ({
    ...state,
    data: data.map(({ key, doc_count: count }) => ({ label: `${key}(${count})`, value: key })),
    loading: false,
  }),
  [getOrderDoneByList.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
  }),
});

export default getOrderDoneByListReducer;
